module.exports = __webpack_public_path__ + "img/智驹首页轮播图Z60---5.14986777.jpg";